import { render, staticRenderFns } from "./EditarActividad.vue?vue&type=template&id=603e4bd6&scoped=true&"
import script from "./EditarActividad.vue?vue&type=script&lang=js&"
export * from "./EditarActividad.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "603e4bd6",
  null
  
)

export default component.exports